// C:\Projects\texe-web\src\components\RichText.tsx
import Linkify from "linkify-react";

type Props = {
  text?: string;
  children?: string;
  shortenUrls?: boolean;
  disableLinkify?: boolean; // Nested <a> hatasını önlemek için
};

function buildOptions(shortenUrls?: boolean) {
  return {
    nl2br: true,
    defaultProtocol: "https",
    target: { url: "_blank" },
    rel: "noopener noreferrer",

    // @kullanici ve #etiket link hedefleri
    formatHref: {
      mention: (href: string) => `/u/${href.slice(1)}`,
      hashtag: (href: string) => `/tag/${href.slice(1)}`
    },

    // 🔑 ÖNEMLİ: Her linke tipine göre class vermek için 'attributes' kullanılır
    attributes: (href: string, type: string) => {
      if (type === "mention") return { class: "mention" };
      if (type === "hashtag") return { class: "hashtag" };
      return {};
    },

    ...(shortenUrls
      ? {
          format: (value: string, type: string) => {
            if (type === "url" && value.length > 40) {
              return value.slice(0, 20) + "…" + value.slice(-15);
            }
            return value;
          },
        }
      : {}),
  } as const;
}

export default function RichText({ text, children, shortenUrls, disableLinkify }: Props) {
  const content =
    typeof text === "string"
      ? text
      : typeof children === "string"
      ? children
      : "";

  // Link içinde kullanılıyorsa, sadece text render et (nested <a> hatasını önler)
  if (disableLinkify) {
    return (
      <div className="richtext-line" style={{ whiteSpace: 'pre-wrap' }}>
        {content}
      </div>
    );
  }

  return (
    <div className="richtext-line">
      <Linkify options={buildOptions(shortenUrls)}>{content}</Linkify>
    </div>
  );
}
